export enum SvarutPropertyNames {
  svarutInvitationScheduledSendDate = 'svarutInvitationScheduledSendDate',
  svarutInvitationSubject = 'svarutInvitationSubject',
  svarutInvitationTemplate = 'svarutInvitationTemplate',
  svarutReminderScheduledSendDate = 'svarutReminderScheduledSendDate',
  svarutReminderSubject = 'svarutReminderSubject',
  svarutReminderTemplate = 'svarutReminderTemplate',
}
